'use strict';

import React from 'react';
import classnames from 'classnames';

const Row = (props) => {
  let _props = {
    ...props,
    className: classnames('row-fluid', props.className),
  };
  return <div {..._props}>{props.children}</div>;
};

export default Row;
